import React from "react";
import Cover1 from "./img/cover1.jpg";
import { Typography } from "@mui/material";
import Discipulado from "./img/discipulado1.jpg";
import Bautismo from "./img/bautismo.jpg";
import Servir from "./img/servir1.jpg";
import Adoracion from "./img/adoracion1.JPG";
import ContactForm from "./contactForm";
import "./nuevo.css";

function Nuevo() {
  return (
    <>
      <div className="img-container">
        <img src={Cover1} alt="iglesia-la-fe" />
        <Typography
          variant="h1"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
            zIndex: 1,
          }}
        >
          Bienvenido
        </Typography>
      </div>

      <section className="page-section">
        <div className="container">
          <div
            className="features-header"
          >
            <Typography variant="h3" style={{ width: "100%", textAlign: "center" }}>
              Que esperar en nuestros cultos
            </Typography>
          </div>

          <div className="features-container">
            {/* Adoración Section */}
            <div className="feature-row">
              <div className="feature-text">
                <Typography
                  variant="subtitle1"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--primary-color)" }}
                >
                  Adoración
                </Typography>
                <Typography
                  variant="h2"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--text-color)" }}
                >
                  Una Bienvenida
                </Typography>
                <Typography
                  variant="body1"
                  style={{ lineHeight: 1.6, color: "var(--primary-color)" }}
                >
                  Te queremos recibir con brazos abiertos
                </Typography>
              </div>
              <div className="feature-image">
                <img src={Adoracion} alt="Adoración en la iglesia" />
              </div>
            </div>

            {/* Discipulado Section */}
            <div className="feature-row" >
              <div className="feature-text">
                <Typography
                  variant="subtitle1"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--primary-color)" }}
                >
                  Discipulado
                </Typography>
                <Typography
                  variant="h2"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--text-color)" }}
                >
                  Crecimiento Espiritual
                </Typography>
                <Typography
                  variant="body1"
                  style={{ lineHeight: 1.6, color: "var(--primary-color)" }}
                >
                  Aprende y crece en tu fe con nosotros
                </Typography>
              </div>
              <div className="feature-image">
                <img src={Discipulado} alt="Discipulado en la iglesia" />
              </div>
            </div>

            {/* Bautismo Section */}
            <div className="feature-row">
              <div className="feature-text">
                <Typography
                  variant="subtitle1"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--primary-color)" }}
                >
                  Bautismo
                </Typography>
                <Typography
                  variant="h2"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--text-color)" }}
                >
                  Un Nuevo Comienzo
                </Typography>
                <Typography
                  variant="body1"
                  style={{ lineHeight: 1.6, color: "var(--primary-color)" }}
                >
                  Celebra tu decisión de seguir a Cristo
                </Typography>
              </div>
              <div className="feature-image">
                <img src={Bautismo} alt="Bautismo en la iglesia" />
              </div>
            </div>

            {/* Servir Section */}
            <div className="feature-row" >
              <div className="feature-text">
                <Typography
                  variant="subtitle1"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--primary-color)" }}
                >
                  Servir
                </Typography>
                <Typography
                  variant="h2"
                  component="h2"
                  gutterBottom
                  style={{ color: "var(--text-color)" }}
                >
                  Usando Nuestros Dones
                </Typography>
                <Typography
                  variant="body1"
                  style={{ lineHeight: 1.6, color: "var(--primary-color)" }}
                >
                  Encuentra tu lugar para servir en la iglesia
                </Typography>
              </div>
              <div className="feature-image">
                <img src={Servir} alt="Sirviendo en la iglesia" />
              </div>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>
    </>
  );
}

export default Nuevo;
